import debug from 'debug';

const log = debug('itp:runtime:document-title');

export class DocumentTitle {
  private readonly defaultTitle: string;
  private readonly postfix: string;
  private current: string | null = null;
  private currentOwner: unknown = null;

  constructor(defaultTitle: string, postfix: string = '') {
    this.defaultTitle = defaultTitle;
    this.postfix = postfix;

    document.title = this.title;
  }

  get title(): string {
    if (this.current) {
      return `${this.current}${this.postfix}`;
    }
    return `${this.defaultTitle}${this.postfix}`;
  }

  set(title: string, owner?: unknown) {
    const nextOwner = owner ?? null;
    if (this.current === title && this.currentOwner === nextOwner) {
      return;
    }
    this.current = title;
    this.currentOwner = nextOwner;
    log('set [%s]', this.title);
    document.title = this.title;
  }

  reset(owner?: unknown) {
    if (owner !== undefined && owner !== this.currentOwner) {
      return;
    }
    if (this.current === null) {
      return;
    }
    this.current = null;
    this.currentOwner = null;
    log('reset [%s]', this.title);
    document.title = this.title;
  }
}
